import getApi from "@/lib/axios/authAxiosInstance";
import {VuexParams, Params} from "@/interfaces/actionParamsInterface";

export function getInvoices({ commit }: VuexParams, {callback, data}: Params) {
    const axios = getApi();

    axios
        .get('/api/invoices',{
            params: {
                ...(data?.conditions ? {conditions: JSON.stringify(data.conditions)} : {}),
                ...(data?.count ? {count: data.count} : {}),
                ...(data?.select ? {select: data.select} : {}),
            }
        })
        .then((response) => {
            callback(response.data)
        })
        .catch((error) => {
            callback({error: error.response?.data?.message || error.message})
        });
}
